export const MalwareDisputeReasons = {
  FALSE_POSITIVE: 'FALSE_POSITIVE',
} as const;

export type MalwareDisputeReasonsKey = keyof typeof MalwareDisputeReasons;

export const MalwareDisputeReasonLabels: Record<MalwareDisputeReasonsKey, string> = {
  FALSE_POSITIVE: 'Package incorrectly flagged as malware',
};

export type MalwareDisputeReasonsType = typeof MalwareDisputeReasons[keyof typeof MalwareDisputeReasons];

export type MalwareDispute = {
  id: number;
  createdBy: number;
  createdAt: Date;
  resolvedBy: number | null;
  resolvedAt: Date | null;
  disputedIssueId: number;
  reason: MalwareDisputeReasonsType;
  comment: string | null;
};
